import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const InputsWrapper = styled.div`
	margin-bottom: 20px;
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: center;
`;

export const ExpectedColumnsText = styled.p`
	margin-top: 4px;
	text-align: center;
	font-weight: 500;
`;
